<template>
  <div>
    <div
      id="platmap-modal"
      class="embinfobox basic"
      v-bind:style="[
        {
          top: `${lotPosition ? lotPosition.top + 'px' : 'auto'}`,
          left: `${
            lotPosition
              ? (zoomLevel > 18 || !underlay
                  ? lotPosition.left
                  : lotPosition.left + 25) + 'px'
              : 'auto'
          }`,
        },
        zoomStyles,
      ]"
      ref="baseElement"
      v-on="
        isKioskMode
          ? { touchstart: start, touchmove: move, touchend: end }
          : undefined
      "
    >
      <!-- Above Arrow for underlay false-->
      <div
        v-if="isShowModalAboveArrowUnderlay"
        v-bind:style="[{ left: `${lotPosition.arrowPosition}px` }]"
        class="arrow-pointer arrow-top-underlay"
      ></div>
      <div v-bind:class="['map-card']">
        <i
          aria-label="close icon"
          class="emb_closeicon"
          @click="beforeClose"
        ></i>
        <div
          v-if="!lodash.isEmpty(lotInfo)"
          class="map-card-body"
          :class="lotStatus"
        >
          <div class="flexCol mb-4" :class="lotStatus">
            <div class="flexRow items-end lot-top-block">
              <h3 class="lotid-title">Site {{ lotId }}</h3>
              <span
                class="lotinfo-colors"
                v-bind:style="{ color: lotInfo.lot.color }"
              >
              <SoldPendingStatus
                v-if="lotInfo.lot.status === 'Sold Pending'"
                svgClass="dsize"
              />

              <SoldContengencyStatus
                v-else-if="lotInfo.lot.status === 'Sold Contingency'"
                svgClass="dsize"
              />
                <i
                v-else
                  v-bind:style="{ backgroundColor: lotInfo.lot.color }"
                  class="dsize"
                ></i>
                {{ lotInfo.lot.status === 'QMI' ? 'Quick Move-In' : lotInfo.lot.status }}
              </span>
            </div>
            <div class="location-block" v-if="lotInfo.lot.address">
              <span class="location-block-title wo-line">
                {{ lotInfo.lot.address }}
              </span>
              <i class="location-block-icon">
                <Location />
              </i>
              <span class="location-block-title font-semibold">
                {{ lotInfo.neighborhoodName }}
              </span>
            </div>
            <h4
              class="lotinfo-mktitle"
              v-if="
                lotInfo.lot.marketing_headline &&
                ![
                  availableStatus.SOLD,
                  Status.SOLD_CLOSED,
                  Status.SOLD_CONTINGENCY,
                  Status.SOLD_PENDING,
                  Status.RESERVED,
                  Status.RESERVED_LOT_HOLD,
                ].includes(lotInfo.lot.status)
              "
            >
              {{ lotInfo.lot.marketing_headline }}
            </h4>
          </div>

          <div
            class="tabs"
            v-if="
              [availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
                lotInfo.lot.status
              )
            "
          >
            <input
              type="radio"
              name="tabs"
              id="tabone"
              checked
              v-show="lotInfo.homes_plans.length"
            />
            <label for="tabone" v-show="showHomePlanLabel">
              <span v-if="!showFutureHomePlanLabel">
                {{
                  `${lotInfo.homes_plans.length || 0} home plans available`
                }}</span
              >
              <span v-else>Home Plans</span>
            </label>
            <div class="tab" v-if="lotInfo.homes_plans.length">
              <div
                v-if="!!lotInfo.homes_plans.length"
                class="tab-slider"
                v-bind:style="{ display: loading ? 'none' : '' }"
              >
                <Carousel
                  ref="slick"
                  v-bind="sliderOptions"
                  v-if="!!lotInfo.homes_plans.length"
                >
                  <Slide
                    v-for="homePlan in lotInfo.homes_plans"
                    :key="homePlan.id"
                  >
                    <div v-if="!!homePlan.image_url.length">
                      <LazyImage
                        :src="imageSource(homePlan.image_url[0])"
                        :alt="
                          !!homePlan.image_url.length
                            ? homePlan.image_url[0].caption
                            : homePlan.name
                        "
                        :isNeighborhoodImage="false"
                        :showDefaultImage="showDefaultImage"
                      />
                    </div>
                    <div v-if="!!!homePlan.image_url.length">
                      <LazyImage
                        :src="imageSource('')"
                        :alt="homePlan.name"
                        :isNeighborhoodImage="false"
                        :showDefaultImage="showDefaultImage"
                      />
                    </div>

                    <div class="flexDiv mb-5 mt-5">
                      <h2
                        class="homePlan-name"
                        @click="
                          !isKioskMode
                            ? openPlanDetails(homePlan.plan_url)
                            : openKioskPlanView(homePlan.id)
                        "
                        style="cursor: pointer"
                      >
                        {{ homePlan.name }}
                        <span
                          v-if="
                            [availableStatus.FUTURE_HOME].includes(
                              lotInfo.lot.status
                            )
                          "
                        >
                          {{ homePlan.elevation }}
                        </span>
                      </h2>
                      <div class="price-block">
                        <span
                          class="price-block-panel-text"
                          v-if="
                            !!homePlan.price_high &&
                            ![availableStatus.FUTURE_HOME].includes(
                              lotInfo.lot.status
                            )
                          "
                          >Starts at</span
                        >
                        <div class="price-block-panel">
                          <span
                            v-if="
                              [availableStatus.AVAILABLE].includes(
                                lotInfo.lot.status
                              ) && homePlan.price_low !== 0
                            "
                            >{{
                              formatPrice(
                                lotInfo.lot.net_premium + homePlan.price_low
                              )
                            }}</span
                          >
                          <!-- <span v-if="checkRangeAndFutureHome(homePlan)">-</span>
                          <span v-if="checkRangeAndFutureHome(homePlan)">{{
                            formatPrice(
                              lotInfo.lot.net_premium + homePlan.price_high
                            )
                          }}</span> -->
                        </div>
                      </div>
                    </div>

                    <p class="amenities-list mb-8">
                      <span v-if="!!homePlan.sqft_low || !!homePlan.sqft_high">
                        <span
                          v-if="
                            checkLowRange('sqft_low', 'sqft_high', homePlan)
                          "
                          >{{ formatSquareFeet(homePlan.sqft_low) }}</span
                        >
                        <span
                          v-if="isRange(homePlan.sqft_low, homePlan.sqft_high)"
                          >-</span
                        >
                        <span v-if="!!homePlan.sqft_high">{{
                          formatSquareFeet(homePlan.sqft_high)
                        }}</span>
                        sq. ft. |
                      </span>
                      <span
                        v-if="!!homePlan.stories_low || !!homePlan.stories_high"
                      >
                        <span
                          v-if="
                            checkLowRange(
                              'stories_low',
                              'stories_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.stories_low }}</span
                        >
                        <span
                          v-if="
                            isRange(homePlan.stories_low, homePlan.stories_high)
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.stories_high">{{
                          homePlan.stories_high
                        }}</span>
                        story |
                      </span>
                      <span
                        v-if="
                          !!homePlan.bedrooms_low || !!homePlan.bedrooms_high
                        "
                      >
                        <span
                          v-if="
                            checkLowRange(
                              'bedrooms_low',
                              'bedrooms_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.bedrooms_low }}</span
                        >
                        <span
                          v-if="
                            isRange(
                              homePlan.bedrooms_low,
                              homePlan.bedrooms_high
                            )
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.bedrooms_high">{{
                          homePlan.bedrooms_high
                        }}</span>
                        bed |
                      </span>
                      <span
                        v-if="
                          !!homePlan.fullbaths_low || !!homePlan.fullbaths_high
                        "
                      >
                        <span
                          v-if="
                            checkLowRange(
                              'fullbaths_low',
                              'fullbaths_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.fullbaths_low }}</span
                        >
                        <span
                          v-if="
                            isRange(
                              homePlan.fullbaths_low,
                              homePlan.fullbaths_high
                            )
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.fullbaths_high">{{
                          homePlan.fullbaths_high
                        }}</span>
                        full baths |
                      </span>
                      <span
                        v-if="
                          !!homePlan.halfbaths_low || !!homePlan.halfbaths_high
                        "
                      >
                        <span
                          v-if="
                            checkLowRangeHalfBath(
                              'halfbaths_low',
                              'halfbaths_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.halfbaths_low }}</span
                        >
                        <span
                          v-if="
                            isRangeHalfBath(
                              homePlan.halfbaths_low,
                              homePlan.halfbaths_high
                            )
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.halfbaths_high">{{
                          homePlan.halfbaths_high
                        }}</span>
                        half baths |
                      </span>
                      <span
                        v-if="
                          !!homePlan.garagebays_low ||
                          !!homePlan.garagebays_high
                        "
                      >
                        <span
                          v-if="
                            checkLowRange(
                              'garagebays_low',
                              'garagebays_high',
                              homePlan
                            )
                          "
                          >{{ homePlan.garagebays_low }}</span
                        >
                        <span
                          v-if="
                            isRange(
                              homePlan.garagebays_low,
                              homePlan.garagebays_high
                            )
                          "
                          >-</span
                        >
                        <span v-if="!!homePlan.garagebays_high">{{
                          homePlan.garagebays_high
                        }}</span>
                        car garage
                      </span>
                    </p>
                  </Slide>
                  <template #addons>
                    <div
                      class="carousel-navigation"
                      v-if="!showFutureHomePlanLabel"
                    >
                      <Navigation />
                    </div>
                  </template>
                </Carousel>
              </div>
            </div>

            <!--tab2-->
            <input
              type="radio"
              name="tabs"
              id="tabtwo"
              v-show="!!lotInfo.lot.images.length"
              @click="handleSiteReInit()"
            />
            <label for="tabtwo" v-show="!!lotInfo.lot.images.length"
              >Site photos</label
            >
            <div
              class="tab site-photo"
              v-if="!!lotInfo.lot.images.length && isSiteTabActive"
            >
              <div class="tab-slider relative">
                <Carousel
                  :key="
                    lotInfo.lot.images.map((img) => img.seq_position).join('-')
                  "
                  ref="siteSlick"
                  v-bind="sliderOptions"
                  v-if="!!lotInfo.lot.images.length"
                >
                  <Slide
                    v-for="image in lotInfo.lot.images"
                    :key="image.seq_position"
                  >
                    <LazyImage
                      :src="imageSource(image)"
                      :alt="image.caption"
                      :isNeighborhoodImage="false"
                    />
                    <p class="slider-caption" v-if="!!image.caption">
                      {{ image.caption }}
                    </p>
                  </Slide>
                  <template #addons>
                    <div
                      class="carousel-navigation"
                      v-if="lotInfo.lot.images.length > 1"
                    >
                      <Navigation />
                    </div>
                  </template>
                </Carousel>
              </div>
              <div class="flexDiv">
                <h2 class="homePlan-name green">
                  {{ messages.sitePhotosH3Message }}
                </h2>
              </div>
              <p class="amenities-list">{{ messages.sitePhotosPMessage }}</p>
            </div>
          </div>
          <template
            v-else-if="
              [
                availableStatus.QUICK_MOVE_IN,
                availableStatus.QMI,
                availableStatus.MODEL,
              ].includes(lotInfo.lot.status)
            "
          >
            <span
              class="location-block-date"
              v-if="lotInfo.homes_plans[0]?.move_in_date"
              >Move-in date:
              {{
                new Date() >= new Date(lotInfo.homes_plans[0]?.move_in_date)
                  ? 'Immediate'
                  : formatDate(lotInfo.homes_plans[0]?.move_in_date)
              }}</span
            >
            <div :class="{ tabs: lotStatus == 'qmi' }">
              <input
                type="radio"
                name="tabs"
                id="tabone"
                checked
                v-show="lotStatus == 'qmi' && lotInfo.homes_plans.length"
              />
              <label
                for="tabone"
                v-show="lotStatus == 'qmi' && lotInfo.homes_plans.length"
                >Home Plans</label
              >
              <div
                class="tab"
                v-for="homePlan in lotInfo.homes_plans"
                :key="homePlan.id"
              >
                <div
                  class="flexDiv"
                  v-if="![availableStatus.QMI, availableStatus.QUICK_MOVE_IN].includes(lotInfo.lot.status)"
                >
                  <h2
                    class="homePlan-name"
                    v-on="
                      !isKioskMode && homePlan.plan_url
                        ? { click: () => openPlanDetails(homePlan.plan_url) }
                        : undefined
                    "
                    :style="[
                      !isKioskMode
                        ? { cursor: 'pointer' }
                        : { pointerEvents: 'none', textDecoration: 'none' },
                    ]"
                  >
                    <span>{{ convertToTitleCase(homePlan.name) }}</span>
                    <span v-if="homePlan.elevation"
                      >&nbsp;{{ homePlan.elevation }}</span
                    >
                  </h2>
                </div>
                <div class="tab-slider">
                  <Carousel ref="slick" v-bind="sliderOptions">
                    <Slide
                      v-for="homePlanImage in homePlan.image_url"
                      :key="homePlanImage.seq_position"
                      class="tab-slider"
                    >
                      <LazyImage
                        :src="imageSource(homePlanImage)"
                        :alt="homePlanImage.caption"
                        :isNeighborhoodImage="false"
                      />
                      <p class="slider-caption" v-if="!!homePlanImage.title">
                        {{ homePlanImage.title }}
                      </p>
                    </Slide>
                    <div v-if="!homePlan.image_url.length">
                      <LazyImage
                        :src="imageSource('')"
                        :alt="''"
                        :isNeighborhoodImage="false"
                      />
                    </div>
                    <template #addons>
                      <div
                        class="carousel-navigation"
                        v-if="homePlan.image_url.length > 1"
                      >
                        <Navigation />
                      </div>
                    </template>
                  </Carousel>
                </div>
                <div
                  class="flexDiv mb-5"
                  v-if="[availableStatus.QMI, availableStatus.QUICK_MOVE_IN].includes(lotInfo.lot.status)"
                >
                  <h2
                    class="homePlan-name"
                    @click="
                      !isKioskMode
                        ? openPlanDetails(homePlan.plan_url)
                        : openKioskPlanView(homePlan.id)
                    "
                    style="cursor: pointer"
                  >
                    <span>{{ homePlan.name }}</span>
                    <span v-if="homePlan.elevation"
                      >&nbsp;{{ homePlan.elevation }}</span
                    >
                  </h2>
                  <div class="price-block">
                    <span
                      class="price-block-panel"
                      v-if="!!homePlan.price_high"
                    >
                      <span class="understrike" v-if="!!homePlan.wasprice">
                        {{ formatPrice(homePlan.wasprice) }}
                      </span>
                      {{ formatPrice(homePlan.price_high) }}
                    </span>
                  </div>
                </div>
                <div class="amenities-list mb-8">
                  <span
                    class="under-construction-list"
                    v-if="
                      [availableStatus.QMI, availableStatus.QUICK_MOVE_IN].includes(lotInfo.lot.status) &&
                      !!homePlan.target_date
                    "
                  >
                    {{ homePlan.target_date }}
                  </span>
                  <span v-if="!!homePlan.sqft_high">
                    Square Ft:
                    <span class="nbsp"></span>
                    {{ formatSquareFeet(homePlan.sqft_high) }} |
                  </span>
                  <span v-if="!!homePlan.stories_high">
                    Story:
                    <span class="nbsp"></span>
                    {{ homePlan.stories_high }} |
                  </span>
                  <span v-if="!!homePlan.bedrooms_high">
                    Bedrooms:
                    <span class="nbsp"></span>
                    {{ homePlan.bedrooms_high }} |
                  </span>
                  <span v-if="!!homePlan.fullbaths_high">
                    Full Baths:
                    <span class="nbsp"></span>
                    {{ homePlan.fullbaths_high }} |
                  </span>
                  <span v-if="!!homePlan.halfbaths_high">
                    Half Baths:
                    <span class="nbsp"></span>
                    {{ homePlan.halfbaths_high }} |
                  </span>
                  <span v-if="!!homePlan.garagebays_high">
                    Garage:
                    <span class="nbsp"></span>
                    {{ homePlan.garagebays_high }}-car
                  </span>
                </div>
              </div>

              <!--tab2-->
              <input
                type="radio"
                name="tabs"
                id="tabtwo"
                v-show="!!lotInfo.lot.images.length && lotStatus == 'qmi'"
                @click="handleSiteReInit()"
              />
              <label
                for="tabtwo"
                v-show="!!lotInfo.lot.images.length && lotStatus == 'qmi'"
                >Site photos</label
              >
              <div
                class="tab site-photo"
                v-show="!!lotInfo.lot.images.length && lotStatus == 'qmi'"
              >
                <div class="tab-slider relative">
                  <Carousel
                    :key="
                      lotInfo.lot.images
                        .map((img) => img.seq_position)
                        .join('-') +
                      '-' +
                      isSiteTabActive
                    "
                    ref="siteSlick"
                    v-bind="sliderOptions"
                    v-if="!!lotInfo.lot.images.length"
                  >
                    <Slide
                      v-for="image in lotInfo.lot.images"
                      :key="image.seq_position"
                    >
                      <LazyImage
                        :src="imageSource(image)"
                        :alt="image.caption"
                        :isNeighborhoodImage="false"
                      />
                      <p class="slider-caption" v-if="!!image.caption">
                        {{ image.caption }}
                      </p>
                    </Slide>
                    <template #addons>
                      <div
                        class="carousel-navigation"
                        v-if="lotInfo.lot.images.length > 1"
                      >
                        <Navigation />
                      </div>
                    </template>
                  </Carousel>
                </div>
                <div class="flexDiv">
                  <h3 class="homePlan-name green">
                    {{ messages.sitePhotosH3Message }}
                  </h3>
                </div>
                <p class="amenities-list">{{ messages.sitePhotosPMessage }}</p>
              </div>
            </div>
          </template>
          <div
            v-else-if="
              [
                availableStatus.SOLD,
                availableStatus.SOLD_CLOSED,
                availableStatus.SOLD_CONTINGENCY,
                availableStatus.SOLD_PENDING,
                availableStatus.RESERVED_LOT_HOLD,
              ].includes(lotInfo.lot.status)
            "
          >
            <div v-if="!!lotInfo.homes_plans.length">
              <div class="sold">
                <h2 class="homePlan-name mb-8">
                  <span>{{ lotInfo.homes_plans[0].name }}</span>
                  <span v-if="!!lotInfo.homes_plans[0].elevation">
                    &nbsp;{{ lotInfo.homes_plans[0].elevation }}</span
                  >
                </h2>
              </div>
              <div
                class="tab"
                v-if="
                  !!lotInfo.homes_plans[0].image_url.length &&
                  !!lotInfo.homes_plans[0].image_url[0].image_url
                "
              >
                <div class="tab-slider">
                  <LazyImage
                    :src="imageSource(lotInfo.homes_plans[0].image_url[0])"
                    :alt="lotInfo.homes_plans[0].image_url[0].caption"
                    :isNeighborhoodImage="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="showSoldMessage && !isSalesOrLandView" class="soldHomes-msg" id="mobileText">
            {{ trailingText[0] }}
            <span class="linkScheduleVisit" @click="openContactInfo()">{{
              linkOpenConatactInfo
            }}</span>
            {{ trailingText[1] }}
          </div>

          <button
            v-if="selfGuidedTourUrl"
            class="btn schedule-visit-btn"
            @click="openSelfGuidedTour()"
          >
            Self Guided Tour
          </button>
          <button
            v-else-if="!suppressScheduleVisit() && !isSalesOrLandView"
            class="btn schedule-visit-btn"
            @click="openContactInfo()"
          >
            Schedule a Visit
            <!-- <span class="icon icon-right-white-arrow"></span> -->
          </button>
        </div>
        <div v-if="errorMessage">{{ errorMessage }}</div>
      </div>

      <!-- Arrow divs for left right top bottom -->
      <div
        v-if="bottomArrowCondition(`left`, `top`)"
        v-bind:style="{ top: `${lotPosition.arrowPosition}px` }"
        class="arrow-pointer arrow-top-left"
      ></div>
      <div
        v-if="bottomArrowCondition(`right`, `top`)"
        v-bind:style="{ top: `${lotPosition.arrowPosition}px` }"
        class="arrow-pointer arrow-top-right"
      ></div>
      <div
        v-if="bottomArrowCondition(`left`, `bottom`)"
        v-bind:style="{ top: `${lotPosition.arrowPosition}px` }"
        class="arrow-pointer arrow-bottom-left"
      ></div>
      <div
        v-if="bottomArrowCondition(`right`, `bottom`)"
        v-bind:style="{ top: `${lotPosition.arrowPosition}px` }"
        class="arrow-pointer arrow-bottom-right"
      ></div>
      <div
        v-if="hasMobile && underlay"
        v-bind:style="{ left: `${lotPosition.left}px` }"
        class="arrow-pointer arrow-top"
      ></div>
      <div
        v-if="hasTablet && underlay"
        v-bind:style="{ left: `${lotPosition.arrowPosition}px` }"
        class="arrow-pointer arrow-top"
      ></div>
      <div
        v-if="isShowModalDownArrowUnderlay"
        v-bind:style="[{ left: `${lotPosition.arrowPosition}px` }]"
        class="arrow-pointer arrow-bottom"
      ></div>
      <!-- Arrow divs for left right top bottom -->
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  reactive,
  computed,
  watch,
  onMounted,
  onUpdated,
  onBeforeUnmount,
  nextTick,
  toRefs,
  inject,
} from 'vue';
import lodash from 'lodash';
import { isMobile, isTablet, isIE } from 'mobile-device-detect';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import LazyImage from './../LazyImage.vue';
import { apiFetchLotInfo } from '../../api';
import {
  HomesPlan,
  LotDetail,
  LotInfo,
  LotPosition,
  NeighborhoodInfo,
} from './../../types';
import {
  Status,
  ModalType,
  Scalers,
  LinkOpenConatactInfo,
} from './../../constant';
import Location from '@/assets/icons/Location.vue';
import {
  calcZoom,
  formatPrice,
  getPlatMapModalPosition,
  convertToTitleCase,
  getTouchesCenter,
  getZoomDistance,
  addImageScaler,
} from './../../core';
import { apiMessages } from '../../api/message-api';
import SoldPendingStatus from '@/assets/icons/SoldPendingStatus.vue';
import SoldContengencyStatus from '@/assets/icons/SoldContengencyStatus.vue';

const props = defineProps<{
  lotId: string;
  position: LotPosition;
  isKioskMode: boolean;
  selectedNeighborhoodIds: string[];
  neighborhoods: NeighborhoodInfo[];
  zoomLevel: number;
  underlay: boolean;
}>();
const {
  lotId,
  position,
  isKioskMode,
  selectedNeighborhoodIds,
  neighborhoods,
  zoomLevel,
  underlay,
} = toRefs(props);
const emit = defineEmits<{
  (
    e: 'showPlanFutureLotFlyout',
    payload: { lotInfo: LotInfo; lotId: string }
  ): void;
  (e: 'openModal', modalName: string): void;
  (e: 'calculateContactInfoTopPosition'): void;
  (e: 'updateLotPosition', lotPosition: LotPosition): void;
  (
    e: 'handlePrintSelectionClick',
    payload: {
      printOptionSelected: boolean;
      showHomeLevel: boolean;
      actualLevels: any;
      selectedLevel: string;
    }
  ): void;
  (
    e: 'updateLotInfo',
    payload: { lotInfo: LotInfo | LotDetail; lotId: string }
  ): void;
  (e: 'closeLotInfo'): void;
}>();

const isSalesOrLandView = inject('setSelectionDropdown', ref(false));
const availableStatus = Status;
const lotInfo = ref<LotInfo>({} as LotInfo);
const lotPosition = ref<LotPosition>({} as LotPosition);
const hasMobile = ref(!!(isMobile && !isTablet));
const hasTablet = ref(isTablet);
const errorMessage = ref('');
const loading = ref(isIE);
const messages = ref<any>({});
const trailingText = ref<string[]>([]);
const linkOpenConatactInfo = LinkOpenConatactInfo;
const zoom = ref(1);
const zoomCenter = ref({ x: 0, y: 0 });
const lastDistance = ref(0);
const width = ref(window.innerWidth);
const height = ref(window.innerHeight);
const lastX = ref<number | null>(null);
const lastY = ref<number | null>(null);
const x = ref(0);
const y = ref(0);
const transition = ref({
  transform: null as any,
  origin: 'transform-origin 400ms linear' as any,
});
const sliderOptions = ref({
  itemsToShow: 1,
});
const minZoom = ref(1);
const maxZoom = ref(10);
const minZoomBounce = ref(0.015);
const maxZoomBounce = ref(0.015);
const speed = ref(0.5);
const showDefaultImage = ref(false);
const slick = ref<any>(null);
const siteSlick = ref<any>(null);
const baseElement = ref<any>(null);

const mode = inject('mode', ref(''));

watch(lotId, async (val, oldVal) => {
  if (val !== oldVal) {
    resetZoom();
    await fetchLotInfo();
    if (!underlay.value) resetModalTop();
  }
});

watch(selectedNeighborhoodIds, (val, oldVal) => {
  if (val !== oldVal) emit('closeLotInfo');
});

watch(
  position,
  (val, oldVal) => {
    if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
      lotPosition.value = val;
    }
  },
  { deep: true }
);

const showHomePlanLabel = computed(
  () =>
    lotInfo.value.homes_plans?.length &&
    [availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot?.status
    )
);

const isShowModalAboveArrowUnderlay = computed(
  () =>
    !underlay.value &&
    (hasMobile.value || hasTablet.value) &&
    lotPosition.value.positionModal === 'below'
);

const isShowModalDownArrowUnderlay = computed(
  () =>
    !underlay.value &&
    (hasMobile.value || hasTablet.value) &&
    lotPosition.value.positionModal === 'above'
);

const lotStatus = computed(() => {
  let status = lotInfo.value.lot?.status;
  if ([availableStatus.QUICK_MOVE_IN, availableStatus.QMI].includes(status))
    status = 'qmi';
  else if (
    [
      availableStatus.SOLD,
      availableStatus.SOLD_CLOSED,
      availableStatus.SOLD_CONTINGENCY,
      availableStatus.SOLD_PENDING,
      availableStatus.AVAILABLE,
    ].includes(status)
  )
    status = status.toLowerCase();
  return status;
});

const showFutureHomePlanLabel = computed(
  () =>
    lotInfo.value.homes_plans?.length &&
    [availableStatus.FUTURE_HOME].includes(lotInfo.value.lot?.status)
);

const zoomStyles = computed(() => {
  let t = '';
  if (transition.value.transform) t += transition.value.transform;
  if (transition.value.origin)
    t += (t.length > 0 ? ', ' : '') + transition.value.origin;
  return {
    transform: `scale(${zoom.value}) translate3d(${x.value}px, ${y.value}px, 0px)`,
    transition: t,
  };
});

onMounted(async () => {
  lotPosition.value = position.value;
  await fetchLotInfo();
  if (!underlay.value) resetModalTop();
});

onUpdated(() => {
  nextTick(() => {
    if (isIE) loading.value = false;
    if (Object.keys(lotInfo.value).length && !isMobile && !isTablet) {
      updateModalPosition();
    }
  });
});

onBeforeUnmount(() => {
  const el = baseElement.value as HTMLElement | undefined;
  if (el) {
    el.removeEventListener('touchstart', start);
    el.removeEventListener('touchmove', move);
    el.removeEventListener('touchend', end);
  }
  if (!underlay.value && hasMobile.value) {
    document.querySelector('.embtoolbox')?.classList.toggle('mobhide');
    document.querySelector('.mobile-legends')?.classList.toggle('mobhide');
    document.querySelector('.cp-filter')?.classList.toggle('mobhide');
  }
});

function resetModalTop() {
  if (
    lotInfo.value &&
    lotPosition.value.positionModal === 'above' &&
    (!lotInfo.value.homes_plans.length ||
      !lotInfo.value.homes_plans[0].image_url?.length)
  ) {
    lotPosition.value.top += 230;
  }
}

async function fetchLotInfo() {
  lotInfo.value = {} as LotInfo;
  let lotNeighborhood = '';
  let currentLotNeighborhoodId = lotId.value.split('-')[0];
  const data = await apiFetchLotInfo(
    currentLotNeighborhoodId,
    lotId.value,
    mode.value
  );
  if (data.result.lot.id === lotId.value) {
    lotNeighborhood =
      neighborhoods.value.find(
        (n) => n.neighborhood_code === currentLotNeighborhoodId
      )?.marketing_name || '';
    if (data.message) {
      errorMessage.value = 'Information for this lot is not yet available';
    } else {
      lotInfo.value = data.result;
      lotInfo.value.neighborhoodName = lotNeighborhood;
      errorMessage.value = '';
      emit('showPlanFutureLotFlyout', {
        lotInfo: lotInfo.value,
        lotId: lotId.value,
      });
    }
  }
  emit('updateLotInfo', {
    lotInfo: lotInfo.value,
    lotId: lotId.value,
    isFromModal: true,
  });
}

function resetZoom() {
  zoom.value = 1;
  zoomCenter.value.x = 0;
  zoomCenter.value.y = 0;
  x.value = 0;
  y.value = 0;
}
async function loadMessages() {
  const { messages: msg } = await apiMessages('PlatMapModal');
  messages.value = msg;
  trailingText.value =
    messages.value.soldHomesMessage.split(linkOpenConatactInfo);
}

function handleReInit() {
  nextTick(() => {
    (slick.value as any)?.reSlick();
  });
}

const isSiteTabActive = ref(false);

function handleSiteReInit() {
  isSiteTabActive.value = true;
  nextTick(() => {
    (siteSlick.value as any)?.slideTo(0);
  });
}

function beforeClose() {
  lotInfo.value = {} as LotInfo;
  const timer = setTimeout(() => {
    emit('closeLotInfo');
    clearTimeout(timer);
  }, 10);
}
const formatPriceFn = (value: number) => {
  return formatPrice(value);
};

const formatSquareFeet = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formatDate = (moveInDate: string) => {
  const date = new Date(moveInDate);
  const formattedDate = date.toDateString().split(' ');
  return `${formattedDate[1]} ${formattedDate[2]}, ${formattedDate[3]}`;
};

const openPlanDetails = (planURL: string) => {
  window.open(`${planURL}`, `HomePlans_WindowName`);
};

const openKioskPlanView = (planCode: string) => {
  // console.log('PlatMapModal...');
  // console.log('planCode = ' + planCode);
  // console.log('jobNumber? = ' + lotInfo.value.lot.id);
  // console.log('nbCode?: ' + lotId.value.split("-")[0]);
  // console.log('selectedneighborhoodIds:');
  // console.log(JSON.stringify(selectedNeighborhoodIds.value));
  console.log('lotInfo = ');
  console.log(JSON.stringify(lotInfo.value) || 'no lotinfo');
  let nbCode = lotInfo.value.lot.id.split("-")[0] || '';
  let pCode = planCode || '';
  let kioskPlanLink = `${process.env.VUE_APP_KIOSK_URL}planView?`;
  if (lotStatus.value === Status.AVAILABLE.toLowerCase()) {
    kioskPlanLink += `plan_code=${pCode}&neighborhood_code=${nbCode}`;
    console.log('kioskPlanLink 1: ' + kioskPlanLink);
  } else if (lotStatus.value === 'qmi') {
    kioskPlanLink += `job_number=${lotInfo.value.lot.id}&neighborhood_code=${nbCode}`;
    console.log('kioskPlanLink 2: ' + kioskPlanLink);
  }
  window.open(`${kioskPlanLink}`, `HomePlans_WindowName`);
};

const openContactInfo = () => {
  emit('calculateContactInfoTopPosition');
  emit('handlePrintSelectionClick', {
    printOptionSelected: false,
    showHomeLevel: false,
    actualLevels: [],
    selectedLevel: '',
  });
  emit('closeLotInfo');
  emit('openModal', ModalType.CONTACT_INFO);
};
const isRange = (val_low: number | null, val_high: number | null) => {
  return val_low != null && val_low != val_high && !!val_high && !!val_low;
};

const isRangeHalfBath = (val_low: number | null, val_high: number | null) =>
  val_low != null && val_high != null && val_high != 0 && val_low != val_high;

const suppressScheduleVisit = () => {
  return (
    [
      Status.SOLD,
      Status.SOLD_CLOSED,
      Status.SOLD_CONTINGENCY,
      Status.SOLD_PENDING,
      Status.RESERVED,
      Status.RESERVED_LOT_HOLD,
      Status.FUTURE_HOME,
    ].includes(lotInfo.value?.lot?.status) || isKioskMode.value
  );
};

const NTER_NOW_URL_PATTERN = /^https?:\/\//i;

/**
 * NterNow self-guided tour link for a Quick Move-In home. Empty unless the QMI
 * publishes a usable link and the Schedule a Visit CTA would otherwise show.
 */
const selfGuidedTourUrl = computed(() => {
  if (isSalesOrLandView.value || suppressScheduleVisit()) return '';
  if (![Status.QMI, Status.QUICK_MOVE_IN].includes(lotInfo.value?.lot?.status))
    return '';

  const nterNowUrl = lotInfo.value?.homes_plans?.[0]?.nter_now_url?.trim() ?? '';
  return NTER_NOW_URL_PATTERN.test(nterNowUrl) ? nterNowUrl : '';
});

const openSelfGuidedTour = () => {
  window.open(selfGuidedTourUrl.value, '_blank');
};

const showSoldMessage = computed(() => {
  return (
    [
      Status.SOLD,
      Status.SOLD_CLOSED,
      Status.SOLD_CONTINGENCY,
      Status.SOLD_PENDING,
      Status.FUTURE_HOME,
    ].includes(lotInfo.value?.lot?.status) || isKioskMode.value
  );
});

const bottomArrowCondition = (xPosition: string, yPosition: string) => {
  return (
    !hasMobile.value &&
    !hasTablet.value &&
    lotPosition.value?.xPosition === xPosition &&
    lotPosition.value?.yPosition === yPosition
  );
};

const imageSource = (src: any) => {
  if (typeof src === 'object' && src.image_url) {
    return addScaler(src.image_url);
  } else {
    showDefaultImage.value = true;
    return require('@/assets/images/home-not-available.png');
  }
};

const addScaler = (url: string) => {
  return addImageScaler(url);
};

const checkLowRange = (
  property1: keyof HomesPlan,
  property2: keyof HomesPlan,
  homePlan: HomesPlan
) => {
  const status = lotInfo.value?.lot?.status;
  return (
    (![Status.AVAILABLE, Status.FUTURE_HOME].includes(status) &&
      homePlan[property1] != null &&
      homePlan[property1]) ||
    ([Status.AVAILABLE, Status.FUTURE_HOME].includes(status) &&
      homePlan[property1] !== homePlan[property2] &&
      homePlan[property1])
  );
};
const checkLowRangeHalfBath = (
  property1: string,
  property2: string,
  homePlan: HomesPlan
) => {
  return (
    (![availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != null) ||
    ([availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != homePlan[property2] &&
      homePlan[property1] != null)
  );
};

const updateModalPosition = () => {
  const lotElement = document.getElementById(lotId.value) as HTMLElement | null;
  const modelContainer = document.getElementById(
    'platmap-modal'
  ) as HTMLElement | null;
  if (!lotElement || !modelContainer) return;

  const elementPosition = lotElement.getBoundingClientRect();
  const lotPos = getPlatMapModalPosition(
    elementPosition,
    modelContainer.clientHeight,
    zoomLevel.value
  );

  if (!lodash.isEqual(lotPosition.value, lotPos)) {
    emit('updateLotPosition', lotPos);
  }
};

const start = (event: TouchEvent) => {
  if (event.touches.length === 2) {
    handlePinchStart(event);
  }
};

const handlePinchStart = (event: TouchEvent) => {
  const { x, y } = getTouchCenter(
    getTouchesCenter(event.touches[0], event.touches[1])
  );
  if (zoom.value < maxZoom.value) {
    zoomCenter.value.x = x;
    zoomCenter.value.y = y;
  }
  lastDistance.value = getZoomDistance(event.touches[0], event.touches[1]);
};

const getTouchCenter = ({ x: cx, y: cy }: { x: number; y: number }) => {
  const rect = baseElement.value?.getBoundingClientRect();
  if (!rect) return { x: 0, y: 0 };
  return {
    x: cx - rect.left,
    y: cy - rect.top,
  };
};

const move = (event: TouchEvent) => {
  if (event.touches.length === 2) {
    handlePinchMove(event);
  } else {
    handlePanMove(event);
  }
};

const handlePinchMove = (event: TouchEvent) => {
  const dist = getZoomDistance(event.touches[0], event.touches[1]);
  const last = dist / lastDistance.value;
  const scale = calcZoom(
    minZoom.value - minZoomBounce.value,
    maxZoom.value + maxZoomBounce.value,
    zoom.value * last
  );

  if (
    zoom.value < maxZoom.value ||
    (zoom.value >= maxZoom.value && scale < zoom.value)
  ) {
    zoom.value = scale;
  }
  lastDistance.value = dist;
};

const checkRangeAndFutureHome = (homePlan: HomesPlan) => {
  return (
    isRange(homePlan.price_low, homePlan.price_high) &&
    lotInfo.value?.lot?.status !== availableStatus.FUTURE_HOME
  );
};

const handlePanMove = (event: TouchEvent) => {
  if (zoom.value > 1) {
    const touch = event.touches[0];
    const cx = touch.clientX;
    const cy = touch.clientY;

    if (!lastX.value || !lastY.value) {
      lastX.value = cx;
      lastY.value = cy;
      return;
    }

    const rect = baseElement.value?.getBoundingClientRect();
    if (!rect) return;

    let diffX = (cx - lastX.value) * speed.value;
    let diffY = (cy - lastY.value) * speed.value;

    transition.value.transform = null;

    x.value += diffX;
    y.value += diffY;

    // bounds
    if (rect.left > 0 && diffX > 0) x.value -= diffX;
    if (rect.right < width.value && diffX < 0) x.value -= diffX;
    if (rect.top > 0 && diffY > 0) y.value -= diffY;
    if (rect.bottom < height.value && diffY < 0) y.value -= diffY;

    // next move
    lastX.value = cx;
    lastY.value = cy;
  }
};

const end = (event: TouchEvent) => {
  if (zoom.value <= minZoom.value) {
    resetZoom();
  } else {
    lastX.value = 0;
    lastY.value = 0;
  }
};
defineExpose({
  beforeClose,
});

onMounted(() => {
  loadMessages();
});
</script>

<style lang="scss">
.embinfobox {
  position: absolute;
  max-width: var(--mapCardWidth);
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -khtml-user-select: none;
  touch-action: pan-y;
  z-index: map-get($z-index, embinfo-popup);

  @include mobile-standard {
    // left: 50% !important;
    transform: translateX(-50%);
  }

  .carousel__prev,
  .carousel__next {
    --dsize: 25px;
    --dsizeBg: rgba(53, 53, 53, 0.7);
    --dsizebdr: transparent;
    top: calc(var(--mapCardImgHeight) / 2);

    &:before {
      -webkit-filter: invert(1) brightness(2);
      filter: invert(1) brightness(2);
      height: 13px;
    }

    &:hover,
    &:focus {
      background-color: var(--dsizeBg);
    }

    &.carousel__prev {
      left: calc(calc(var(--cardPaddingX) * -1) + 2px);
    }

    &.carousel__next {
      right: calc(calc(var(--cardPaddingX) * -1) + 2px);
    }
  }

  .emb-card_body_content {
    .site span,
    p,
    h4 {
      @extend %font14;
    }

    h4 {
      font-weight: 700;
      color: $light-green;
      margin-bottom: 7px;
    }
  }

  .tab {
    min-height: 120px;

    .slick-current {
      position: relative;
    }

    .siteSlick-current {
      position: relative;
    }

    &-slider {
      .slick-track {
        margin: 0;
        overflow: hidden !important;
      }

      .slider-caption {
        --textHeight: 32px;
        position: relative;
        text-align: center;
        font-size: 12px;
        z-index: 2;
        width: 100%;
        color: #555;
        background: rgba(255, 255, 255, 0.8);
        margin-top: calc(var(--textHeight) * -1);
        height: var(--textHeight);
        @extend %flex-allcenter;
      }
    }
  }

  .site-photo {
    .homePlan-name.green {
      font-size: 18px;
      line-height: 25px;
      text-decoration: none;
      color: $primary;
      font-weight: 600;
    }
  }

  .sold .tab-slider img {
    cursor: default;
  }
}

.schedule-visit-btn {
  @include font(12px, 700);
  line-height: 16px;
  padding: 4px 12px;
  min-height: auto;
  border-radius: 5px;
  min-width: auto;
}

.linkScheduleVisit {
  text-decoration: underline;
  color: $lime-green-new;
  cursor: pointer;
}

.tabs {
  margin-bottom: 6px;
}
</style>
